import API from "../../service/api"

class Page extends API{
  /**
     * 群组首页-群组详细信息
     */
  async group_view(groupinfoID){
    return await this.sendget("group/page/group_view/?groupinfoID="+groupinfoID);
  }
  async group_view_bar(groupinfoID){
    return await this.sendget('group/page/group_view_bar/?groupinfoID='+groupinfoID);
  }
  async group_view_member(groupinfoID, lastID){
    return await this.sendget("group/page/group_view_member/?groupinfoID="+groupinfoID+"&lastID="+lastID);
  }
  async group_view_article(groupinfoID, lastID){
    return await this.sendget(`group/page/group_view_article/?groupinfoID=${groupinfoID}&lastID=${lastID}`)
  }
  async group_view_topic(groupinfoID){
    return await this.sendget( `group/page/group_view_topic/?groupinfoID=${groupinfoID}`)
  }
  async article_list(params){
    return await this.sendget(`group/page/article_list/?groupinfoID=${params.groupinfoID}&topicID=${params.topicID}&lastID=${params.lastID}`)
  }
  async article_view(id){
    return await this.sendget(`group/page/article_view/?id=${id}`)
  }
  async article_view_comment(params){
    return await this.sendget(`group/page/article_view_comment/?id=${params.id}&lastID=${params.lastID}`)
  }
  async recommand_group(){
    return await this.sendget("group/page/hot_group/")
    // return await this.sendget("group/page/recommand_group/?lastID="+lastID);
  }
    async new_group(){
        return await this.sendget("group/page/new_group/")
        // return await this.sendget("group/page/recommand_group/?lastID="+lastID);
    }
  async article_search_in_group(params) {
    return await this.sendget(`group/page/article_search/?keyword=${ params.keyword }&groupinfoID=${ params.groupID }&lastID=${ params.lastID }`)
  }

  async sendget(url){
    try{
        let rs = await this.get(url);
        return rs;
    }
    catch(e){
        console.log(e)
        return false;
    }
  }

  async sendpost(url,data){
      try{
          let rs = await this.post(url,data);
          return rs;
      }
      catch(e){
          console.log(e)
          return false;
      }
  }

}

export default new Page();